import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const Loader = ({ containerStyle, size = 40 }) => {
  const defaultStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '66vh',
    width: '100%',
  };

  return (
    <Box sx={containerStyle || defaultStyle}>
      <CircularProgress size={size} />
    </Box>
  );
};

export const ImageLoader = ({ fullWidth = false } = {}) => {
  const imageLoaderStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '180px',
    width: fullWidth ? '100%' : '180px',
    maxWidth: '100%',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    boxSizing: 'border-box',
  };

  return <Loader containerStyle={imageLoaderStyle} size={30} />;
};

export default Loader;
